module.exports = __webpack_public_path__ + "static/media/cp19.a57998b0.pdf";